import { createContext } from 'react';

const { Consumer, Provider } = createContext({
  mainRef: null,
  modalRef: null,
});

export { Provider as LayoutProvider, Consumer as LayoutConsumer };
